import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useNotificationsHeaderItemStyles = makeStyles(
  (theme: Theme) => ({
    linkButtons: {
      color: theme.palette?.mode === 'dark' ? '#B6B5B6' : '#9D9EA6',
      padding: '0',
      minWidth: '0',
      '& .MuiButton-startIcon': {
        margin: '0',
      },
      '& .v5-MuiButton-icon': {
        margin: '0',
      },
      '&:hover': {
        background: 'inherit',
        color: theme.palette.mode === 'light' ? '#74757E' : '#FFFFFF',
        textDecoration: 'none',
      },

      '& .v5-MuiBadge-badge': {
        fontSize: '0.625rem',
        minWidth: 18,
        height: 18,
        padding: '0 4px',
      },
    },
  }),
  { name: 'NotificationsHeaderItem' },
);
